import { Card, CardBody, Input, Typography } from "@material-tailwind/react";
import { useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import ErrorParagraph from "../../components/common/ErrorParagraph";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ChangePasswordValidation,
  changePasswordForm,
} from "../auth/authValidations";
// import OtpInput from "react-otp-input";
import ClickBaseButton from "../../components/common/buttons/ClickBaseButton";
import ApiRoutes from "../../services/apiRoutes";
import api from "../../services/apiService";
import { toast } from "react-toastify";
import { handleErrorMessage } from "../../utility";
// import ChangePin from "../../components/settings/ChangePin";
// import { useMutation } from "react-query";
// import AuthService from "../../services/authService";

function Account() {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  // const [otp, setOtp] = useState("");
  // const [changePin, setChangePin] = useState(false);
  const [loadingPassword, setPasswordLoading] = useState(false);
  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm<changePasswordForm>({
    resolver: yupResolver(ChangePasswordValidation),
    mode: "onChange",
  });

  async function handlePasswordChange(data: changePasswordForm) {
    console.log(data);
    setPasswordLoading(true);
    try {
      const request = await api.post(ApiRoutes.changePassword, {
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
      });
      console.log(request.data);
      if (request.data.payload.statusCode === 200) {
        toast.success("Password changed successfully");
      }
    } catch (error) {
      console.log(error);

      handleErrorMessage(error, "Unable to change password");
    } finally {
      reset();
      setPasswordLoading(false);
    }
  }

  // const user = AuthService.user?.data;

  // const otpMutation = useMutation(
  //   () =>
  //     apiDirect.post(ApiRoutes.changePinOtp, {
  //       email: user?.email,
  //       phoneNumber: user?.phoneNumber,
  //       otpType: "0",
  //     }),
  //   {
  //     onError(error) {
  //       console.log(error);
  //     },
  //     onSuccess(data) {
  //       console.log(data);
  //     },
  //   }
  // );

  return (
    <Card placeholder={undefined}>
      <CardBody placeholder={undefined}>
        <Typography
          placeholder={undefined}
          className="font-semibold mb-2 text-black"
        >
          Change Password
        </Typography>
        <div className="md:flex md:w-full items-start">
          <div className="mb-3 md:mb-5">
            <Input
              type={passwordShown ? "text" : "password"}
              size="lg"
              label="old Password"
              containerProps={{ className: "bg-gray-100 rounded-md" }}
              className="border-none"
              labelProps={{
                className: "before:content-none after:content-none ml-2",
              }}
              icon={
                passwordShown ? (
                  <MdVisibility onClick={() => setPasswordShown(false)} />
                ) : (
                  <MdVisibilityOff onClick={() => setPasswordShown(true)} />
                )
              }
              crossOrigin={undefined}
              {...register("oldPassword")}
            />
            {errors.oldPassword && (
              <ErrorParagraph message={errors.oldPassword.message!} />
            )}
          </div>
          <div className="md:ml-4">
            <Input
              type={confirmPasswordShown ? "text" : "password"}
              size="lg"
              label="New Password"
              containerProps={{ className: "bg-gray-100 rounded-md" }}
              className="border-none"
              labelProps={{
                className: "before:content-none after:content-none ml-2",
              }}
              icon={
                confirmPasswordShown ? (
                  <MdVisibility
                    onClick={() => setConfirmPasswordShown(false)}
                  />
                ) : (
                  <MdVisibilityOff
                    onClick={() => setConfirmPasswordShown(true)}
                  />
                )
              }
              crossOrigin={undefined}
              {...register("newPassword")}
            />
            {errors.newPassword && (
              <ErrorParagraph message={errors.newPassword.message!} />
            )}
          </div>
          <ClickBaseButton
            isLoading={loadingPassword}
            className="md:mt-0 md:mx-3 md:w-min "
            onClick={handleSubmit(handlePasswordChange)}
          >
            Submit
          </ClickBaseButton>
        </div>
        {/* <Typography
          placeholder={undefined}
          className="font-semibold mt-4 text-black"
        >
          Transaction PIN
        </Typography>
        <Typography placeholder={undefined} className="mt-2 text-black">
          This helps to keep your account more secured
        </Typography>
        <hr className="md:w-2/6 my-4" />
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={4}
          inputStyle={{
            margin: "16px",
            backgroundColor: "#f3f4f6",
            padding: "6px",
            width: "40px",
            height: "40px",
            appearance: "textfield",
            MozAppearance: "textfield",
          }}
          renderInput={(props) => <input {...props} type="number"/>}
        />
        <ClickBaseButton
          onClick={() => setChangePin((prev) => !prev)}
          className="lg:w-1/3 md:w-1/2 w-full mt-4"
        >
          Change PIN
        </ClickBaseButton>
        <ChangePin
        loadingOtp={otpMutation.isLoading}
          open={changePin}
          handleOpen={() => setChangePin((prev) => !prev)}
        /> */}
      </CardBody>
    </Card>
  );
}

export default Account;
